import React, {Component} from 'react';
import {Factory as ModeTabsFactory} from './components/desktop/factory';
import {connect} from 'react-redux';

class ModeTabs extends Component {
    render() {
        const {sportConfig} = this.props;

        const ModeTabs = ModeTabsFactory.getComponent(sportConfig);

        if (!ModeTabs) {
            return null;
        }

        return <ModeTabs />;
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;

    return {
        sportConfig,
    };
}

const ModeTabsComponent = connect(mapStatesToProps)(ModeTabs);

export {ModeTabsComponent};
